<template>
    <div class="rootStatus">
        <vs-table 
            ref="table" 
            :data="statuses"
            id="tableData"
            @search="searchFilter"
            @sort="sortFilter"
            :sst="true"
            noDataText="Sem dados disponíveis"
            search
            style="padding-right: 24px !important;"
        >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center pl-4">
                <div
                  class="
                    p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                    text-lg font-medium text-base text-primary border border-solid border-primary
                  "
                  @click="openSidebar(context='create', data=undefined)"
                >
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                  <span
                    class="ml-2 text-base text-primary"
                  >
                    Adicionar Nova
                  </span>
                </div>
            </div>

            <div>
                <vs-dropdown
                        vs-trigger-click
                        class="cursor-pointer mr-4"
                    >
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">                                
                            {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                            {{
                                statuses.length - currentPage * itemsPerPage > 0
                                    ? currentPage * itemsPerPage
                                    : statuses.length
                            }} de {{ queriedItems }}
                        </span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage=4">
                            <span>4</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=15">
                            <span>15</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
        </div>
            <template slot="thead">
                <vs-th class="text-base"  sort-key="name" style="width: 15%; padding-left: 8%;">
                    Nome
                </vs-th>
                <vs-th class="text-base" sort-key="step" style="width: 15%; padding-left: 8%;">
                    Estagio
                </vs-th>
                <vs-th class="text-base" style="width: 10%; padding-left: 8%;">
                    Cor
                </vs-th>
                <vs-th class="text-base" style="width: 15%; padding-left: 9%; padding-left: 8%;">
                    Ações
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                    :data="tr" 
                    :key="tr.id"
                    :id="tr.id"
                    v-for="(tr, index) in statuses"
                    >
                        <vs-td :title="tr.name" :data="tr.name" style="padding-left: 8%;">
                            <p class="product-name font-medium truncate overflow-hidden" @click="modalToReadMessage(tr.name)">
                                {{ foramtedMessageTemplate(tr.name) }}
                            </p>
                        </vs-td>

                        <vs-td v-if="tr.step == 'Em Andamento'" :data="tr.step" style="padding-left: 8%;">
                            <vs-chip color="primary"> 
                                <p class="text-left ml-2">
                                    {{ tr.step }}
                                </p>
                            </vs-chip>
                        </vs-td>

                        <vs-td v-else :data="tr.step" style="padding-left: 8%;">
                            <vs-chip color="success"> 
                                <p class="text-left ml-2">
                                    {{ tr.step }}
                                </p>
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="tr.color" style="padding-left: 8%;">
                            <p class="text-left">
                                <div v-bind:style="colorOfVisualization(tr.color)" class="color_visualization"/>
                            </p>
                        </vs-td>

                        <vs-td style="padding-left: 8%;">
                            <template v-if="tr.integration_id !== null">
                                <div class="w-12">
                                    <vx-tooltip text="Este status pertence ao ERP, portanto, não pode ser alterado." position="top">
                                        <feather-icon
                                        icon="HelpCircleIcon"
                                        svgClasses="w-12 h-5 hover:text-primary stroke-current"
                                        />
                                    </vx-tooltip>
                                </div>
                            </template>

                            <template v-else-if="tr.is_editable === false">
                                <div class="w-12">
                                    <vx-tooltip text="Não é possível editar este status. Ele é criado de forma padrão e não pode ser removido ou alterado devido ao seu uso nos relatórios." position="top">
                                        <feather-icon
                                        icon="HelpCircleIcon"
                                        svgClasses="w-12 h-5 hover:text-primary stroke-current"
                                        />
                                    </vx-tooltip>
                                </div>
                            </template>

                            <template v-else>
                                <feather-icon
                                icon="EditIcon"
                                svgClasses="w-12 h-5 hover:text-primary stroke-current"
                                @click="openSidebar(context='update', data=tr)"
                                />
                
                                <feather-icon
                                icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-0"
                                @click="openPopUp(tr)"
                                />
                            </template>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <div class="sidebar-status">
            <vs-sidebar
            click-not-close
            position-right
            default-index="1"
            color="primary"
            class="add-new-data-sidebar items-no-padding"
            spacer
            parent="body"
            v-model="sidebarIsActive"
            >
                <div class="mt-6 mb-4 flex items-center justify-between px-6">
                    <h4 v-if="sidebarData.id === undefined">ADICIONAR NOVO STATUS</h4>
                    <h4 v-else>ATUALIZAR STATUS</h4>
                    <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="sidebarIsActive=false"
                    />
                </div>
                <vs-divider class="mb-0"/>

                <div>
                    <vs-input
                    id="input-adjustment"
                    label="Nome do Status"
                    class="mt-3 ml-8 w-5/6"
                    name="name"
                    v-model="sidebarData.name"
                    :maxlength="maxLength"
                    />
                    <p v-if="sidebarData.name.length >= maxLength" class="text-danger mt-2 ml-8 text-xs">Limite máximo de 200 caracteres excedido</p>
                </div>

                <div class="ml-2 mt-6 mb-4 px-6">
                    <span class="text-base ml-2" style="font-size: 12px !important;">
                        Escolha o Estágio:
                    </span> <br>
                    <select v-model="sidebarData.step" id="myselect">
                        <option value="in_progress">Em Andamento</option>
                        <option value="finished">Finalizado</option>
                    </select>
                </div>

                <div class="ml-3 mt-8 mb-4 flex items-center px-6">
                    <label class="input-color-label-status" for="input-color-status">
                        <feather-icon
                            size="large"
                            icon="EditIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current mt-3"
                            class="mr-2"
                        />
                        Escolha a Cor do Status
                    </label>
                    <div class="input-color-container-status">
                        <input v-model="sidebarData.color" class="input-color-status" id="input-color-status" type="color">
                    </div>
                </div>

                <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
                    <vs-button class="mr-6" @click="sendData()">
                      Salvar
                    </vs-button>
                    <vs-button type="border" color="danger" @click="sidebarIsActive=false">
                      Cancelar
                    </vs-button>
                </div>
            </vs-sidebar>
        </div>

        <div>
            <vs-popup title="Remover Status" :active.sync="modalIsActive" @close="closePopUp" class="sizePopup">
                <p class="text-center">Deseja realmente remover o Status de nome <strong> {{deleteData.name}} </strong>
                    e Estágio <strong>{{deleteData.step}}</strong> ?
                </p> <br>

                <div v-if="linkedOrdersCount > 0">
                    <p class="text-center">
                        Existe{{ linkedOrdersCount > 1 ? 'm': '' }} <strong>{{ linkedOrdersCount }}</strong>
                        pedido{{ linkedOrdersCount > 1 ? 's': '' }} vinculado{{ linkedOrdersCount > 1 ? 's': '' }}
                        a esse status
                    </p>
                    <p class="text-center">
                        Escolha abaixo outro status para atribuir a
                        esse{{ linkedOrdersCount > 1 ? 's': '' }}
                        pedido{{ linkedOrdersCount > 1 ? 's': '' }}:
                    </p>

                    <div class="full-width flex justify-center vs-align-center my-8">

                        <vs-dropdown style="width: 60%;" class="formatHeadStatus">
                            <vs-button
                                class="btn-drop px-3 attendance-span"
                                type="filled"
                                icon="expand_more"
                                :color="transferStatus.color"
                                size="small"
                                @click.stop.prevent=""
                                style="font-size:1rem !important; width: 100%"
                                icon-after
                            >
                                <span>
                                    {{ transferStatus.name }}
                                </span>
                            </vs-button>

                            <vs-dropdown-menu>
                                <div v-for="(item, index) in statuses" :key="index">
                                    <vs-dropdown-item
                                        v-if="item.id !== deleteData.id"
                                        :style="colorOfOption(item.color)"
                                        style="color: #fff; width: 100%;"
                                        class="m-0"
                                        @click.prevent="changeTransferStatus(item)"
                                    >
                                        <span>{{ item.name }}</span>
                                    </vs-dropdown-item>
                                </div>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                
                <div class="w-full d-flex justify-content-flex-end">
                  <vs-button color="danger" @click.stop="deleteStatus">Remover</vs-button>
                </div>
            </vs-popup>
        </div>

        <div class="mt-3 mr-4">
            <vs-pagination
                :total="totalPages"
                v-model="page"
                max="7"
        /></div>
    </div>
</template>

<script>
    import moduleHttp from '@/http/requests/status';
    import moduleStatus from '@/store/status/moduleStatus'
    import ordersApi from '@/http/requests/orders'

    export default {
        name: 'Status',
        data() {
            return {
                sidebarIsActive: false,
                modalIsActive: false,
                newStatus: {
                    name: '',
                    step: '',
                    color: '#28c35e'
                },
                sidebarData: {
                    id: undefined,
                    name: '',
                    step: '',
                    color: ''
                },
                deleteData: {
                    id: undefined,
                    name: '',
                    step: ''
                },
                orderBy: {
                    name: 'name',
                    type: 'ASC'
                },
                search: "",
                page: 1,
                itemsPerPage: 4,
                isMounted: false,
                linkedOrdersCount: 0,
                transferStatus: {
                    id: null,
                    name: '',
                    step: '',
                    color: ''
                },
                maxLength: 201,
                exceededMaxLength: false
            }
        },
        watch: {
            'page'() {
                this.fetch()
            },
            'itemsPerPage'() {
                this.page = 1
                this.fetch()
            },
        },
        computed: {
            totalPages() {
                return this.$store.state.status && this.$store.state.status.statuses.total_pages
                    ? this.$store.state.status.statuses.total_pages
                    : 0
            },
            queriedItems() {
                return this.$store.state.status && this.$store.state.status.statuses.total_items
                    ? this.$store.state.status.statuses.total_items
                    : 0
            },
            currentPage() {
                if (this.isMounted) {
                  return this.$refs.table.currentx;
                }

                return 0;
            },
            statuses() {
                return this.$store.state.status && this.$store.state.status.statuses
                    ? this.$store.state.status.statuses.items : []
            }
        },
        methods: {
            measureTextWidth(text, fontSize) {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                context.font = `${fontSize}px Arial`;
                return context.measureText(text).width;
            },
            foramtedMessageTemplate(message) {
                return message.length >= 50 ? message.substring(0, 50) + '...' : message;
            },
            modalToReadMessage(message) {
                const maxPixelWidth = 360;
                const fontSize = 16;
                let formattedMessage = '';
                let line = '';

                for (let i = 0; i < message.length; i++) {
                    line += message[i];
                    const lineWidth = this.measureTextWidth(line, fontSize);

                    if (lineWidth > maxPixelWidth) {
                    formattedMessage += line + '\n';
                    line = '';
                    }
                }

                if (line.length > 0) {
                    formattedMessage += line;
                }

                return this.$vs.dialog({
                    color: 'primary',
                    title: `Nome do Status`,
                    text: formattedMessage,
                    acceptText: 'Fechar',
                });
            },
            changeTransferStatus(status) {
                this.transferStatus = status
            },
            colorOfOption(color) {
                return {
                    backgroundColor: color
                }
            },
            async fetch() {
                if (!moduleStatus.isRegistered) {
                    this.$store.registerModule('status', moduleStatus)
                    moduleStatus.isRegistered = true
                }

                await this.$store.dispatch("status/fetchPaginated", {  
                    sortName: this.orderBy.name,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    type: this.orderBy.type,
                    word: this.search
                });
            },
            async searchFilter(searchQuery) {
                this.search = searchQuery;
                this.fetch();
            },
            async sortFilter(sortName) {
                if (sortName !== null) {
                    if (sortName !== this.orderBy.name) {
                        this.orderBy.name = sortName;
                        this.orderBy.type = 'ASC';
                    } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
                        this.orderBy.type = 'DESC';
                    } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
                        this.orderBy.name = 'name';
                        this.orderBy.type = 'ASC';
                    }
                    this.fetch();
                }
            },
            colorOfVisualization(color) { return { backgroundColor: color } },
            openSidebar(context, data) {
                switch (context) {
                    case 'create':
                        this.sidebarData =  {
                            id: undefined,
                            name: '',
                            step: '',
                            color: '#28c35e'
                        }

                        this.sidebarIsActive = true;
                        break;
                    case 'update':
                        this.sidebarData =  {
                            id: data.id,
                            name: data.name,
                            step: data.step === 'Em Andamento' ? 'in_progress' : 'finished',
                            color: data.color
                        }

                        this.sidebarIsActive = true;
                        break;
                    default:
                        break;
                }
            },
            async openPopUp(data) {
                this.deleteData = {
                    id: data.id,
                    name: data.name,
                    step: data.step
                }

                this.transferStatus = data

                const relatedOrders = await ordersApi.fetchAll('chat_tickets.customers.name', 1, 1, 'DESC', '', data.id)
                this.linkedOrdersCount = relatedOrders.data.data.getOrder.total_items
                
                this.modalIsActive = true;
            },
            closePopUp() {
                this.linkedOrdersCount = 0
                this.modalIsActive = false;
                this.transferStatus = {
                    id: null,
                    name: '',
                    step: '',
                    color: ''
                }
            },
            sendData() {
                if (this.sidebarData.id === undefined) {
                    if (this.sidebarData.step === '' || this.sidebarData.name === '') {
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Aviso!',
                            text: 'Você precisa preencher todos os campos para que os dados sejam enviados.',
                            time: 4000
                        });
                    }
                    moduleHttp.create({
                        name: this.sidebarData.name,
                        step: this.sidebarData.step,
                        color: this.sidebarData.color
                    })
                    .then((response) => {
                        this.fetch();
                        this.sidebarIsActive = false;
                        this.sidebarData =  {
                            id: undefined,
                            name: '',
                            step: '',
                            color: '#28c35e'
                        }

                        return this.$vs.notify({
                                color: 'success',
                                title: 'O Status foi criado com sucesso!'
                            });
                        })
                    .catch((error) => {
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao enviar os dados!',
                            text: 'Contate nossa equipe para corrigirmos o erro.',
                            time: 4000
                        });
                    });
                } else {
                    if (this.sidebarData.step === '' || this.sidebarData.name === '') { 
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Aviso!',
                            text: 'Você precisa preencher todos os campos para que os dados sejam atualizados.',
                            time: 4000
                        });
                    }

                    moduleHttp.update(this.sidebarData.id, {
                        name: this.sidebarData.name,
                        step: this.sidebarData.step,
                        color: this.sidebarData.color
                    })
                    .then((response) => {
                        this.fetch();
                        this.sidebarIsActive = false;
                        this.sidebarData =  {
                            id: undefined,
                            name: '',
                            step: '',
                            color: '#28c35e'
                        }

                        return this.$vs.notify({
                            color: 'success',
                            title: 'O Status foi atualizado com sucesso!'
                        });
                    })
                    .catch((error) => {
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao atualizar os dados!',
                            text: 'Contate nossa equipe para corrigirmos o erro.'
                        });
                    });
                }
            },
            deleteStatus() {
                const removeData = {
                    id: this.deleteData.id
                }

                if (this.linkedOrdersCount > 0) {
                    if (this.transferStatus.id === null || this.transferStatus.id === this.deleteData.id) {
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Erro!',
                            text: 'É necessário escolher um novo status para vincular os pedidos relacionados.',
                            time: 4000
                        });
                    }

                    removeData.newOrdersStatusId = this.transferStatus.id
                }

                moduleHttp.delete(removeData)
                .then((response) => {
                    this.deleteData = {
                        id: undefined,
                        name: '',
                        step: ''
                    }
                    
                    this.fetch();
                    this.modalIsActive = false;
                    return this.$vs.notify({
                        color: 'success',
                        title: 'O Status foi deletado com sucesso!'
                    });
                })
                .catch((error) => {
                    this.deleteData = {
                        id: undefined,
                        name: '',
                        step: ''
                    }

                    this.modalIsActive = false;
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro!',
                        text: 'Algo deu errado ao deletar esse status! Contate nossa equipe para corrigirmos.',
                        time: 4000
                    });
                })
            }
        },
        async mounted() {
            await this.fetch();
            this.isMounted = true;
        },
        beforeRouteLeave(to, from, next) {
            if (this.sidebarIsActive) {
                this.sidebarIsActive = false;
                setTimeout( ()=> {
                next();
                }, 2);
            } 
            else if (this.modalIsActive) {
                this.modalIsActive = false;
                setTimeout( ()=> {
                next();
                }, 2);
            }
            else {
                next();
            }
        },
    }
</script>

<style scoped>
    ::v-deep .vs-sidebar {
        z-index: 52010 !important;
        width: 400px !important;
        max-width: 90vw !important;
    }
    ::v-deep .vs-sidebar--background {
        z-index: 52010 !important;
    }
</style>

<style lang="scss"> 
    .rootStatus {
        * {
            margin: 0;
        }
        html {
            line-height: 1.5;
            letter-spacing: 0.02rem;
        }
        .con-tablex.vs-table--content {
            width: 102%; 
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 15px !important;
            padding: 0 1rem;
        }
        thead > tr {
            background-color: transparent !important;
        }
        .vs-table-text {
            text-transform: uppercase;
            font-size: 12px;
        }
        input.input-search.vs-table--search-input {
            height: 45px;
        }
        tbody {
            > tr {
                td {
                    margin-bottom: 100px !important;
                }
                height: 5em;
                box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05%);
                .align-button-flex {
                    .vs-button-text.vs-button--text {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        padding-left: 10px;
                    }
                }
                td.vs-table--td:last-of-type {
                    border-top-right-radius: 10px !important; 
                    border-bottom-right-radius: 10px !important;
                }
                td.vs-table--td:first-of-type {
                    border-top-left-radius: 10px !important; 
                    border-bottom-left-radius: 10px !important;
                }
            }
        }
        .color_visualization {
            width: 35px;
            height: 35px;
            border-radius: 40px;
            border: solid 2px #ddd;
        }
    }
    #myselect {
        width: 334px;
        border-radius: 5px;
        border-color:  #b6bebdd2;
        background-color: transparent;
        height: 37px;
        padding-left: 10px;
        font-size: 15px;
        color: #676262 !important;
        option {
            color: #676262 !important;
            font-size: 14.5px;
        }
    }
    .input-color-container-status {
        position: relative;
        overflow: hidden;
        width: 40px;
        height: 40px;
        border: solid 2px #ddd;
        border-radius: 40px;
        cursor: pointer;
        margin-left: 8px;
    }
    .input-color-status {
        position: absolute;
        right: -8px;
        top: -8px;
        width: 56px;
        height: 56px;
        border: none;
        cursor: pointer;
    }
    
    .input-color-label-status {
        font-size: 13px;
        cursor: pointer;
        color: #676262 !important;
        display: flex;
        align-items: center;
        svg.feather.feather-edit.w-5.h-5.hover\:text-primary.stroke-current.mt-3 {
            margin-top: 0 !important;
        }
    }

</style>